import { IInvoiceRow } from '@query/invoices'

/** Invoice-level net (excluding VAT) plus VAT equals gross. */
export const getInvoiceGrossTotal = (netAmount: number, vatAmount: number): number =>
  netAmount + vatAmount

export const getInvoiceRowGrossAmount = (
  row: Pick<IInvoiceRow, 'total_amount' | 'total_vat_amount'>
): number => getInvoiceGrossTotal(row.total_amount, row.total_vat_amount)

/** Sum VAT by rate from row totals (compact card display). */
export const groupInvoiceVatByRate = (
  rows: Pick<IInvoiceRow, 'vat_rate' | 'total_vat_amount'>[]
): Array<[number, number]> => {
  const totals = new Map<number, number>()
  for (const row of rows) {
    totals.set(row.vat_rate, (totals.get(row.vat_rate) ?? 0) + row.total_vat_amount)
  }
  return Array.from(totals.entries()).sort(([a], [b]) => a - b)
}
